import { useParams } from 'react-router-dom';
import { pbPortal } from '../lib/pb';
import { useData } from '../data/DataProvider';

// Shared portal context for client screens (E1).
// Resolves the signed-in client from the PORTAL session (the OTP magic
// link is exchanged for a session on /portal/verify — no secret ever
// travels in the address bar) and builds links on the clean session
// base: /portal/:tenantSlug
export function usePortalClient() {
  const { tenantSlug } = useParams();
  const { data } = useData();
  const record = pbPortal.authStore.record;

  const client = data.clients.find((item) => item.id === record?.client_id)
    || data.clients[0]
    || { id: '', name: 'Client', initials: '??' };

  const slug = tenantSlug || '';
  const base = slug ? `/portal/${slug}` : '/portal';

  return { client, base, tenantSlug: slug };
}
